import { Document, Font, Image, Page, StyleSheet, Text, View, pdf, Link } from '@react-pdf/renderer'
import { useCallback, useEffect, useRef, useState } from 'react'
import { HiArrowDownTray } from 'react-icons/hi2'
import Assessment from '../../API/Assessment/index'
import EuclidBold from '../../Styles/pdfFonts/euclidBold.ttf'
import EuclidItalic from '../../Styles/pdfFonts/euclidItalic.ttf'
import EuclidRegular from '../../Styles/pdfFonts/euclidRegular.ttf'
import { Spinner } from 'react-bootstrap'

const MyPDFDocument = ({ data, keywords, dimensions, strengthWeakness, mockCompetence, allScores }) => (
	<Document>
		<Page style={[styles.page, { padding: 0 }]}>
			<View style={{ width: '100%', height: '100%', padding: 0, margin: 0 }}>
				<Image src='https://assets.mydna.company/pdf-assessment/cover-updated.jpg' cache style={{ height: '110%' }} />
				<View style={styles.roundedBox}>
					<Text style={styles.headerText}>REPORTE</Text>
					<Text style={styles.title}>
						Perfil de{'\n'}
						Competencias
					</Text>
					<Text style={styles.name}>{data.name}</Text>
					<Text style={styles.description}>
						Este reporte es un producto de MyDNA. MyDNA Assessment es una solución de liderazgo para todos para promover, atraer y retener talentos.
					</Text>
					<Text style={styles.footer}>2022 | C Todos los derechos reservados.</Text>
				</View>
			</View>
		</Page>

		<Page style={[styles.page, { padding: 0 }]}>
			<Image src='https://assets.mydna.company/pdf-sucession-plan/Mandalas.jpg' cache style={{ height: '110%' }} />
		</Page>

		<Page style={styles.page}>
			<View style={[styles.roundedTextBox, { marginTop: 20 }]}>
				<Text style={styles.text}>Introducción</Text>
			</View>

			<View style={{ position: 'absolute', marginTop: 80 }}>
				<Text style={styles.defaultText}>
					La herramienta de autoevaluación de Witmegrow es un instrumento confiable, científicamente validado que ha sido desarrollado para comprender
					y describir las fortalezas y oportunidades de mejora de las personas.
				</Text>
				<Text style={styles.defaultText}>
					Partiendo de la base que completaste las preguntas, siguiendo y respetando las instrucciones, en este reporte encontrarás una descripción de
					las competencias que conforman tu "Yo PERSONA", "Yo SOCIAL", "Yo ORGANI- ZACIONAL" y "Yo LIDER".
				</Text>
				<Text style={styles.defaultText}>
					El modelo fue exclusivamente desarrollado para witmegrow por un grupo de científicos expertos, psicólogos laborales y consultores de
					liderazgo, basándose en los distintos modelos de inteligencia emocional, también en estudios realizados como el del World Economic Forum
					sobre las 10 habilidades más requeridas en los profesionales y encuestas aplicadas a profesionales y especialistas del área de Recursos
					Humanos en distintos países de Latinoamérica.
				</Text>
				<Text style={styles.defaultText}>
					Es importante considerar a estos resultados por lo que son, un punto de vista adicional sobre tu progreso hacia tus objetivos. Ciertamente,
					hay factores externos que pueden incidir en los hallazgos y puede ser que alteren los resultados que tú esperabas. Te invitamos a utilizar
					esta información para continuar tu camino de desarrollo personal y profesional.
				</Text>

				<Text style={{ marginLeft: 26, color: '#7c6cec', marginBottom: 20 }}>¿Cómo funciona el modelo?</Text>
				<Text style={styles.defaultText}>
					El modelo de competencias de Witmegrow es un inventario de comportamientos asociados a competencias que está orientado al autoconocimiento.
					En función de las respuestas que indicaste en la autoevaluación, tendrás como resultado tu percepción sobre cada una de las 20 competencias
					de una persona integral. Esto te brindará información sobre el grado de desarrollo de cada una de las competencias, lo cual te ayudará en el
					autodesarrollo profesional y personal.
				</Text>
				<Text style={styles.defaultText}>
					En MyDNA entendemos a las competencias como características o atributos que tienen las personas, relacionadas con sus conocimientos,
					habilidades y actitudes.
				</Text>
				<Text style={styles.defaultText}>
					Las competencias se definen por medio de comportamientos que reflejan el nivel de desarrollo de cada una de ellas. Se parte de un estándar
					alto de efectividad, definido por tipos de comportamientos que desarrollan personas altamente competentes.
				</Text>
				<Text style={styles.defaultText}>Los comportamientos son observables y por lo tanto medibles.</Text>
				<Text style={styles.defaultText}>
					Desde MyDNA te invitamos a que dediques tiempo a leer este reporte, esforzándote en identificar cuáles competencias han logrado una
					incidencia positiva en tu ejercicio de liderazgo y han sido favorables, así como también cuáles te han desafiado y afectado negativamente en
					tu desarrollo personal y profesional.
				</Text>
				<Text style={styles.defaultText}>
					Creemos que más allá de los resultados que obtengas, todas las personas contamos con oportunidades para mejorar nuestras habilidades, con el
					fin de lograr mayor armonía y bienestar en todos los ámbitos de relacionamiento con otros y con nosotros mismos.
				</Text>
			</View>

			<View style={styles.footerPage}>
				<Text style={styles.pageNumber} render={({ pageNumber }) => `${pageNumber}`} fixed />

				<View style={styles.logoContainer}>
					<Image src='https://assets.mydna.company/mydnalogo.png' style={[styles.logo, { marginRight: 5 }]} />
					<Text style={[styles.defaultText, { color: '#465568', margin: 0, lineHeight: 0 }]}>powered by Witmegrow</Text>
				</View>
			</View>
		</Page>

		<Page style={styles.page}>
			<View style={[styles.roundedTextBox, { marginTop: 20 }]}>
				<Text style={styles.text}>Estas son las palabras clave sobre tu perfil que podrían describirte</Text>
			</View>

			<View style={{ marginTop: 110, marginLeft: 20, marginRight: 20 }}>
				<View style={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' }}>
					{keywords?.map(item => (
						<View style={[styles.pill, { width: '30%', marginBottom: 8 }]} key={item.description}>
							<Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>{item.description}</Text>
						</View>
					))}
				</View>
			</View>

			<View style={[styles.roundedTextBox, { marginTop: 230 }]}>
				<Text style={styles.text}>Inventario de autoconocimiento</Text>
			</View>

			<View style={{ position: 'absolute', marginTop: 290 }}>
				<Text style={styles.defaultText}>
					En el inventario de Witmegrow se presentan diversos comportamientos que las personas califican en términos de grado de aceptación de la
					evidencia de esas conductas a través de 5 opciones que van desde:
				</Text>
				<View style={styles.containerOptions}>
					<View style={[styles.option, { alignItems: 'center' }]}>
						<View style={styles.circle}></View>
						<Text style={[styles.defaultText, { margin: 0, lineHeight: 0, color: '#E69138' }]}>Muy en desacuerdo</Text>
					</View>

					<View style={[styles.option, { flexDirection: 'row', alignItems: 'center' }]}>
						<View style={styles.circle}></View>
						<Text style={[styles.defaultText, { margin: 0, lineHeight: 0, color: '#E69138' }]}>En desacuerdo</Text>
					</View>

					<View style={[styles.option, { flexDirection: 'row', alignItems: 'center' }]}>
						<View style={[styles.circle, { borderColor: '#6b7a90' }]}></View>
						<Text style={[styles.defaultText, { margin: 0, lineHeight: 0, color: '#6b7a90' }]}>Neutro</Text>
					</View>

					<View style={[styles.option, { flexDirection: 'row', alignItems: 'center' }]}>
						<View style={[styles.circle, { borderColor: '#8679e9' }]}></View>
						<Text style={[styles.defaultText, { margin: 0, lineHeight: 0, color: '#8679e9' }]}>De acuerdo</Text>
					</View>

					<View style={[styles.option, { flexDirection: 'row', alignItems: 'center' }]}>
						<View style={[styles.circle, { borderColor: '#8679e9' }]}></View>
						<Text style={[styles.defaultText, { margin: 0, lineHeight: 0, color: '#8679e9' }]}>Muy de acuerdo</Text>
					</View>
				</View>

				<Text style={styles.defaultText}>El inventario está conformado por 20 competencias, las cuales se clasifican en 4 dimensiones:</Text>

				{/* Organizational */}
				<View style={[styles.container, { backgroundColor: '#008acd', marginTop: 5, marginBottom: 5 }]}>
					<View style={styles.iconContainer}>
						<Text style={styles.icon}></Text>
					</View>

					<View style={[styles.textContainer, { flexDirection: 'row', alignItems: 'center' }]}>
						<Text style={styles.text}>Yo Organizacional</Text>
						<Text style={[styles.defaultTextContainer, { color: '#FFFFFF' }]}>
							{dimensions.find(d => d.dimension === 'Organizacional')?.brief.description || ''}
						</Text>
					</View>
				</View>
				<Text style={[styles.defaultText, { color: '#465568' }]}>{dimensions.find(d => d.dimension === 'Organizacional')?.brief.brief || ''}</Text>

				{/* Social */}
				<View style={[styles.container, { backgroundColor: '#6c4fdb', marginTop: 5, marginBottom: 5 }]}>
					<View style={styles.iconContainer}>
						<Text style={styles.icon}></Text>
					</View>

					<View style={[styles.textContainer, { flexDirection: 'row', alignItems: 'center' }]}>
						<Text style={styles.text}>Yo Social</Text>
						<Text style={[styles.defaultTextContainer, { color: '#FFFFFF' }]}>
							{dimensions.find(d => d.dimension === 'Social')?.brief.description || ''}
						</Text>
					</View>
				</View>
				<Text style={[styles.defaultText, { color: '#465568' }]}>{dimensions.find(d => d.dimension === 'Social')?.brief.brief || ''}</Text>
			</View>

			<View style={styles.footerPage}>
				<Text style={styles.pageNumber} render={({ pageNumber }) => `${pageNumber}`} fixed />

				<View style={styles.logoContainer}>
					<Image src='https://assets.mydna.company/mydnalogo.png' style={[styles.logo, { marginRight: 5 }]} />
					<Text style={[styles.defaultText, { color: '#465568', margin: 0, lineHeight: 0 }]}>powered by Witmegrow</Text>
				</View>
			</View>
		</Page>

		<Page style={styles.page}>
			<View style={{ position: 'absolute', marginTop: 40 }}>
				{/* Leadership */}
				<View style={[styles.container, { backgroundColor: '#00a28b', marginTop: 5, marginBottom: 5 }]}>
					<View style={styles.iconContainer}>
						<Text style={styles.icon}></Text>
					</View>

					<View style={[styles.textContainer, { flexDirection: 'row', alignItems: 'center' }]}>
						<Text style={styles.text}>Yo Líder</Text>
						<Text style={[styles.defaultTextContainer, { color: '#FFFFFF' }]}>
							{dimensions.find(d => d.dimension === 'Líder')?.brief.description || ''}
						</Text>
					</View>
				</View>
				<Text style={[styles.defaultText, { color: '#465568' }]}>{dimensions.find(d => d.dimension === 'Líder')?.brief.brief || ''}</Text>

				<View style={[styles.container, { backgroundColor: '#d87706', marginTop: 5, marginBottom: 5 }]}>
					<View style={styles.iconContainer}>
						<Text style={styles.icon}></Text>
					</View>

					<View style={[styles.textContainer, { flexDirection: 'row', alignItems: 'center' }]}>
						<Text style={styles.text}>Yo Persona</Text>
						<Text style={[styles.defaultTextContainer, { color: '#FFFFFF' }]}>
							{dimensions.find(d => d.dimension === 'Persona')?.brief.description || ''}
						</Text>
					</View>
				</View>
				<Text style={[styles.defaultText, { color: '#465568' }]}>{dimensions.find(d => d.dimension === 'Persona')?.brief.brief || ''}</Text>
			</View>

			<View style={styles.footerPage}>
				<Text style={styles.pageNumber} render={({ pageNumber }) => `${pageNumber}`} fixed />

				<View style={styles.logoContainer}>
					<Image src='https://assets.mydna.company/mydnalogo.png' style={[styles.logo, { marginRight: 5 }]} />
					<Text style={[styles.defaultText, { color: '#465568', margin: 0, lineHeight: 0 }]}>powered by Witmegrow</Text>
				</View>
			</View>
		</Page>

		<Page style={styles.page}>
			<View style={[styles.roundedTextBox, { marginTop: 20 }]}>
				<Text style={styles.text}>Agrupamos las competencias evaluadas en 4 dimensiones</Text>
			</View>

			<View style={{ position: 'absolute', marginTop: 80 }}>
				<Text style={styles.defaultText}>
					Esta sección te permite contar con una vision global de tus aspectos más destacados. Ten en cuenta que todas las características descriptas
					aquó no se manifiestan en simultáneo y con igual intensidad. Es más probable que se manifiesten sólo algunas de estas características.
				</Text>

				<View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
					<View>
						<View style={[styles.container, { backgroundColor: '#008acd', marginTop: 5, marginBottom: 10, width: 250 }]}>
							<View style={styles.iconContainer}>
								<Text style={styles.icon}></Text>
							</View>

							<View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', flex: 1 }}>
								<View style={{ flexShrink: 1 }}>
									<Text style={[styles.text, { fontSize: 14, marginLeft: 0 }]}>Yo Organizacional</Text>
									<Text style={[styles.defaultTextContainer, { color: '#FFFFFF' }]}>Potencial Ejecutivo</Text>
								</View>
								<Text style={[styles.text, { color: '#FFF', textAlign: 'right', marginLeft: 10 }]}>
									{dimensions?.find(dimension => dimension.dimension === 'Organizacional')?.score_relative || 0}%
								</Text>
							</View>
						</View>
						<Text style={[styles.defaultText, { color: '#465568', width: 240 }]}>
							Presentas elevada capacidad para adelantarte a hechos e implementar planes para concretar proyectos. Trabajas siempre por objetivos y
							con eficiencia ante decisiones importantes. Cuentas con gran orientación al cliente, siendo empático, ofreciendo apoyo e indagando para
							conocer sus necesidades. Exploras el mercado y te mantienes actualizado. Asimismo, logras una muy efectiva gestión del tiempo y
							recursos, con claridad de prioridades, y seguimiento que logran productividad. Frente a nuevas situaciones generas soluciones creativas,
							buscando inspirarte y ampliar tu visión con alternativas posibles para optimizar el trabajo.
						</Text>
					</View>

					<View>
						<View style={[styles.container, { backgroundColor: '#6c4fdb', marginTop: 5, marginBottom: 10, width: 250 }]}>
							<View style={styles.iconContainer}>
								<Text style={styles.icon}></Text>
							</View>

							<View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', flex: 1 }}>
								<View style={{ flexShrink: 1 }}>
									<Text style={[styles.text, { fontSize: 14, marginLeft: 0 }]}>Yo Social</Text>
									<Text style={[styles.defaultTextContainer, { color: '#FFFFFF' }]}>Potencial Interpersonal</Text>
								</View>
								<Text style={[styles.text, { color: '#FFF', textAlign: 'right', marginLeft: 10 }]}>
									{dimensions?.find(dimension => dimension.dimension === 'Social')?.score_relative || 0}%
								</Text>
							</View>
						</View>
						<Text style={[styles.defaultText, { color: '#465568', width: 240 }]}>
							Tienes una gran capacidad para comunicarte efectivamente, ya sea de forma oral, gestual o escrita, lo que te permite comprender e
							interpretar información, contemplando las emociones propias y ajenas. También tienes una elevada capacidad de trabajo en equipo,
							trabajando de modo colaborativo y desarrollando vínculos de confianza y empatía. Gran capacidad para llegar a acuerdos e influenciar,
							buscando satisfacer mutuas necesidades. En el vínculo con los demás posees una total apertura a los otros, más allá de las diferencias y
							sabes que la diversidad de opiniones enriquece el trabajo.
						</Text>
					</View>
				</View>

				<View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
					<View>
						<View style={[styles.container, { backgroundColor: '#00a28b', marginTop: 5, marginBottom: 10, width: 250 }]}>
							<View style={styles.iconContainer}>
								<Text style={styles.icon}></Text>
							</View>

							<View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', flex: 1 }}>
								<View style={{ flexShrink: 1 }}>
									<Text style={[styles.text, { fontSize: 14, marginLeft: 0 }]}>Yo Líder</Text>
									<Text style={[styles.defaultTextContainer, { color: '#FFFFFF' }]}>Potencial de Liderazgo</Text>
								</View>
								<Text style={[styles.text, { color: '#FFF', marginLeft: 10 }]}>
									{dimensions?.find(dimension => dimension.dimension === 'Líder')?.score_relative || 0}%
								</Text>
							</View>
						</View>
						<Text style={[styles.defaultText, { color: '#465568', width: 240 }]}>
							Posees una gran capacidad para mostrar nuevas posibilidades al equipo, logrando inspirar y estimular el logro de objetivos, en un clima
							de armonía y respeto. Cuentas con una elevada habilidad para la toma de decisiones, asumiendo riesgos controlados y análisis racional y
							emocional de opciones que agregan valor, anteponiendo políticas y normas organizacionales. Transmites con naturalidad una visión
							inspiradora, estando un paso adelante y generando alternativas frente a cambios externos. Gran capacidad para gestionar cambios con
							adaptación rápida y efectiva frente a nuevos escenarios, manejando las resistencias e influenciando a otros.
						</Text>
					</View>

					<View>
						<View style={[styles.container, { backgroundColor: '#d87706', marginTop: 5, marginBottom: 10, width: 250 }]}>
							<View style={styles.iconContainer}>
								<Text style={styles.icon}></Text>
							</View>

							<View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', flex: 1 }}>
								<View style={{ flexShrink: 1 }}>
									<Text style={[styles.text, { fontSize: 14, marginLeft: 0 }]}>Yo Persona</Text>
									<Text style={[styles.defaultTextContainer, { color: '#FFFFFF' }]}>Potencial Personal</Text>
								</View>
								<Text style={[styles.text, { color: '#FFF', marginLeft: 10 }]}>
									{dimensions?.find(dimension => dimension.dimension === 'Persona')?.score_relative || 0}%
								</Text>
							</View>
						</View>
						<Text style={[styles.defaultText, { color: '#465568', width: 240 }]}>
							Tienes una gran capacidad de comprender a los demás de forma integral. Eres una persona asertiva y de elevada adaptación al cambio. Eres
							capaz de sobreponerte bien a los obstáculos. Resiliente. Balanceas los distintos roles, sintiéndote en armonía y equilibrio entre lo
							profesional y lo personal. Eres consciente de las propias emociones, lo que te hace ser reflexivo y orientado a la mejora. Eres abierto
							y curioso hacia el aprendizaje, buscando la superación y el desafío que te ayude a evolucionar.
						</Text>
					</View>
				</View>
			</View>

			<View style={styles.footerPage}>
				<Text style={styles.pageNumber} render={({ pageNumber }) => `${pageNumber}`} fixed />

				<View style={styles.logoContainer}>
					<Image src='https://assets.mydna.company/mydnalogo.png' style={[styles.logo, { marginRight: 5 }]} />
					<Text style={[styles.defaultText, { color: '#465568', margin: 0, lineHeight: 0 }]}>powered by Witmegrow</Text>
				</View>
			</View>
		</Page>

		<Page style={styles.page}>
			<View style={[styles.roundedTextBox, { marginTop: 20 }]}>
				<Text style={styles.text}>Competencias más destacadas</Text>
			</View>
			<View style={{ position: 'absolute', marginTop: 80 }}>
				<Text style={styles.defaultText}>
					Tomando en cuenta las dimensiones con mayor y menor puntaje, destacamos las tres competencias que son fortalezas de tu perfil y las tres que
					son oportunidades de mejora.
				</Text>
				<Text style={styles.defaultText}>
					Nuestra recomendación es que siempre trabajes en terna, compuesta por una fortaleza y dos oportunidades de mejora. Y haciendo una
					competencia por vez. O sea, trata de evitar trabajar dos competencias al mismo tiempo, es más efectivo que te focalicecs por completo en una
					sola.
				</Text>

				<View>
					{dimensions &&
						dimensions.map((dimension, index) => {
							const dimensionConfig = [
								{ name: 'Organizacional', backgroundColor: '#dff3fe', fillColor: '#008acd' },
								{ name: 'Social', backgroundColor: '#e2e4fd', fillColor: '#6c4fdb' },
								{ name: 'Persona', backgroundColor: '#fef3c6', fillColor: '#d87706' },
								{ name: 'Líder', backgroundColor: '#c7fff1', fillColor: '#00a28b' },
							]

							const config = dimensionConfig.find(config => config.name === dimension.dimension) || {}

							return (
								<View key={index} style={{ paddingRight: 20, marginRight: 50 }}>
									<Text style={[styles.defaultText, { fontSize: 10, marginBottom: 0 }]}>
										Yo {dimension.dimension} - {dimension.score_relative}%
									</Text>
									<View style={[styles.progressBarContainer, { backgroundColor: config.backgroundColor }]}>
										<View style={[styles.progressBarFill, { width: `${dimension.score_relative}%`, backgroundColor: config.fillColor }]}></View>
									</View>
								</View>
							)
						})}
				</View>

				<View style={{ marginRight: 50 }}>
					<View style={[styles.containerSpecs, { marginLeft: 20, marginTop: 20 }]}>
						<View
							style={[
								styles.leftBox,
								{
									backgroundColor:
										dimensions?.find(item => item.category === 'STRENGTHS')?.dimension === 'Organizacional'
											? '#c0ecfc'
											: dimensions?.find(item => item.category === 'STRENGTHS')?.dimension === 'Social'
											? '#c0ecfc'
											: dimensions?.find(item => item.category === 'STRENGTHS')?.dimension === 'Persona'
											? '#c0ecfc'
											: dimensions?.find(item => item.category === 'STRENGTHS')?.dimension === 'Líder'
											? '#c0ecfc'
											: '',
								},
							]}
						>
							{/* <Text style={[styles.subtitle, { fontSize: 10 }]}>Fortalezas</Text>
							<Text style={[styles.title, { fontSize: 14, marginLeft: 0 }]}>
								{dimensions?.find(item => item.category === 'STRENGTHS')?.dimension}
							</Text> */}
							<Text style={[styles.title, { fontSize: 10, marginLeft: 0, color: 'black' }]}>Fortalezas</Text>
						</View>

						<View style={styles.rightBox}>
							{strengthWeakness?.strengths?.map((item, index) => (
								<Text key={index} style={styles.listText}>
									{index + 1}. {item.description}
								</Text>
							))}
						</View>
					</View>

					<View style={[styles.containerSpecs, { marginLeft: 20 }]}>
						<View
							style={[
								styles.leftBox,
								{
									backgroundColor:
										dimensions?.find(item => item.category === 'WEAKNESSES')?.dimension === 'Organizacional'
											? '#ffe48c'
											: dimensions?.find(item => item.category === 'WEAKNESSES')?.dimension === 'Social'
											? '#ffe48c'
											: dimensions?.find(item => item.category === 'WEAKNESSES')?.dimension === 'Persona'
											? '#ffe48c'
											: dimensions?.find(item => item.category === 'WEAKNESSES')?.dimension === 'Líder'
											? '#ffe48c'
											: '',
								},
							]}
						>
							{/* <Text style={[styles.subtitle, { fontSize: 10 }]}>Oportunidades de Mejora</Text>
							<Text style={[styles.title, { fontSize: 14, marginLeft: 0 }]}>
								{dimensions?.find(item => item.category === 'WEAKNESSES')?.dimension}
							</Text> */}

							<Text style={[styles.title, { fontSize: 10, marginLeft: 0, color: 'black' }]}>Oportunidades de Mejora</Text>
						</View>

						<View style={styles.rightBox}>
							{strengthWeakness?.weaknesses?.map((item, index) => (
								<Text key={index} style={styles.listText}>
									{index + 1}. {item.description}
								</Text>
							))}
						</View>
					</View>
				</View>
			</View>

			<View style={styles.footerPage}>
				<Text style={styles.pageNumber} render={({ pageNumber }) => `${pageNumber}`} fixed />

				<View style={styles.logoContainer}>
					<Image src='https://assets.mydna.company/mydnalogo.png' style={[styles.logo, { marginRight: 5 }]} />
					<Text style={[styles.defaultText, { color: '#465568', margin: 0, lineHeight: 0 }]}>powered by Witmegrow</Text>
				</View>
			</View>
		</Page>

		<Page style={styles.page}>
			<View style={{ marginLeft: 20, marginRight: 20, marginTop: 20 }}>
				<View>
					{mockCompetence.slice(0, 2).map((competence, compIndex) => (
						<>
							<View key={compIndex} style={{ marginTop: 20 }}>
								<View style={[styles.layoutHeader, { backgroundColor: competence.color }]}>
									<Text style={[styles.text, { fontSize: 16, marginLeft: 0 }]}>Yo {competence.title}</Text>
									<Text style={[styles.text, { fontSize: 16 }]}>
										{dimensions?.find(dimension => dimension.dimension === competence.title)?.score_relative || 0}%
									</Text>
								</View>

								<View style={[styles.layoutContent, { border: '1px solid #E0E0E0' }]}>
									{competence.items.map((item, itemIndex) => {
										if (itemIndex % 2 === 0) {
											return (
												<View key={itemIndex} style={styles.layoutRow}>
													<View style={styles.layoutColumn}>
														<View style={{ flexDirection: 'row', alignItems: 'center', display: 'flex' }}>
															<Text style={[styles.text, { marginRight: 5, marginLeft: 0, fontSize: 10, color: '#000' }]}>
																{competence.items[itemIndex].title}
																{competence.items[itemIndex].score != null ? ` - ${competence.items[itemIndex].score}%` : ''}
															</Text>
														</View>
														<Text style={[styles.defaultText, { color: '#465568', marginLeft: 0 }]}>{competence.items[itemIndex].text}</Text>
													</View>

													{competence.items[itemIndex + 1] && (
														<View style={styles.layoutColumn}>
															<View style={{ flexDirection: 'row', alignItems: 'center', display: 'flex' }}>
																<Text style={[styles.text, { marginRight: 5, marginLeft: 0, fontSize: 10, color: '#000' }]}>
																	{competence.items[itemIndex + 1].title}
																	{competence.items[itemIndex + 1].score != null ? ` - ${competence.items[itemIndex + 1].score}%` : ''}
																</Text>
															</View>
															<Text style={[styles.defaultText, { color: '#465568', marginLeft: 0 }]}>{competence.items[itemIndex + 1].text}</Text>
														</View>
													)}
												</View>
											)
										}
										return null
									})}
								</View>
							</View>
						</>
					))}
				</View>
			</View>

			<View style={styles.footerPage}>
				<Text style={styles.pageNumber} render={({ pageNumber }) => `${pageNumber}`} fixed />

				<View style={styles.logoContainer}>
					<Image src='https://assets.mydna.company/mydnalogo.png' style={[styles.logo, { marginRight: 5 }]} />
					<Text style={[styles.defaultText, { color: '#465568', margin: 0, lineHeight: 0 }]}>powered by Witmegrow</Text>
				</View>
			</View>
		</Page>

		<Page style={styles.page}>
			<View style={{ marginLeft: 20, marginRight: 20, marginTop: 20 }}>
				<View>
					{mockCompetence.slice(2, 4).map((competence, compIndex) => (
						<>
							<View key={compIndex} style={{ marginTop: 10 }}>
								<View style={[styles.layoutHeader, { backgroundColor: competence.color }]}>
									<Text style={[styles.text, { fontSize: 16, marginLeft: 0 }]}>Yo {competence.title}</Text>
									<Text style={[styles.text, { fontSize: 16 }]}>
										{dimensions?.find(dimension => dimension.dimension === competence.title)?.score_relative || 0}%
									</Text>
								</View>

								<View style={[styles.layoutContent, { border: '1px solid #E0E0E0' }]}>
									{competence.items.map((item, itemIndex) => {
										if (itemIndex % 2 === 0) {
											return (
												<View key={itemIndex} style={styles.layoutRow}>
													<View style={styles.layoutColumn}>
														<View style={{ flexDirection: 'row', alignItems: 'center', display: 'flex' }}>
															<Text style={[styles.text, { marginRight: 5, marginLeft: 0, fontSize: 10, color: '#000' }]}>
																{competence.items[itemIndex].title}
																{competence.items[itemIndex].score != null ? ` - ${competence.items[itemIndex].score}%` : ''}
															</Text>
														</View>
														<Text style={[styles.defaultText, { color: '#465568', marginLeft: 0 }]}>{competence.items[itemIndex].text}</Text>
													</View>

													{competence.items[itemIndex + 1] && (
														<View style={styles.layoutColumn}>
															<View style={{ flexDirection: 'row', alignItems: 'center', display: 'flex' }}>
																<Text style={[styles.text, { marginRight: 5, marginLeft: 0, fontSize: 10, color: '#000' }]}>
																	{competence.items[itemIndex + 1].title}
																	{competence.items[itemIndex + 1].score != null ? ` - ${competence.items[itemIndex + 1].score}%` : ''}
																</Text>
															</View>
															<Text style={[styles.defaultText, { color: '#465568', marginLeft: 0 }]}>{competence.items[itemIndex + 1].text}</Text>
														</View>
													)}
												</View>
											)
										}
										return null
									})}
								</View>
							</View>
						</>
					))}
				</View>
			</View>

			<View style={styles.footerPage}>
				<Text style={styles.pageNumber} render={({ pageNumber }) => `${pageNumber}`} fixed />

				<View style={styles.logoContainer}>
					<Image src='https://assets.mydna.company/mydnalogo.png' style={[styles.logo, { marginRight: 5 }]} />
					<Text style={[styles.defaultText, { color: '#465568', margin: 0, lineHeight: 0 }]}>powered by Witmegrow</Text>
				</View>
			</View>
		</Page>

		<Page style={styles.page}>
			<View style={[styles.roundedTextBox, { marginTop: 20 }]}>
				<Text style={styles.text}>Ayudas para la acción</Text>
			</View>

			<View style={{ position: 'absolute', marginTop: 80 }}>
				<Text style={styles.defaultText}>
					Una vez seleccionadas las dos oportunidades de mejora a desarrollar y la fortaleza a expandir, estás preparado/a para la acción. Te
					brindamos una serie de consejos para que tu desarrollo personal y profesional sea lo más placentero posible.
				</Text>
				<View style={{ marginLeft: 26 }}>
					<View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
						<View style={styles.circleNumber}>
							<Text style={[styles.text, { fontWeight: 'bold', fontSize: 10, color: '#000', margin: 0, marginLeft: 0 }]}>1</Text>
						</View>
						<Text style={[styles.text, { marginLeft: 0, fontSize: 10, color: '#000' }]}>
							- Visualiza los beneficios que tú recibirás al alcanzar las metas
						</Text>
					</View>
					<Text style={[styles.defaultText, { color: '#465568' }]}>
						Haz una lista de los beneficios que tú recibirás, por ejemplo: mejor equilibrio de mi vida personal y laboral, más tiempo con mi familia o
						amigos, comunicar efectivamente mi visión al equipo de trabajo durante la reunión de coordinación, mejorar el ratio de conversión de
						ventas, etc. ¿cuáles serán tus beneficios?
					</Text>
				</View>
				<View style={{ marginLeft: 26 }}>
					<View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
						<View style={styles.circleNumber}>
							<Text style={[styles.text, { fontWeight: 'bold', fontSize: 10, color: '#000', margin: 0, marginLeft: 0 }]}>2</Text>
						</View>
						<Text style={[styles.text, { marginLeft: 0, fontSize: 10, color: '#000' }]}>- No olvides la disponibilidad de tu tiempo</Text>
					</View>
					<Text style={[styles.defaultText, { color: '#465568' }]}>
						Hay más de 500.000 minutos en un año. Con que dediques 40 minutos por semana de manera recurrente a tu desarrollo personal y profesional
						será más que suficiente. ¿Puedes dedicarle el 0,4% de tu tiempo a tu desarrollo personal y profesional?
					</Text>
				</View>
				<View style={{ marginLeft: 26 }}>
					<View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
						<View style={styles.circleNumber}>
							<Text style={[styles.text, { fontWeight: 'bold', fontSize: 10, color: '#000', margin: 0, marginLeft: 0 }]}>3</Text>
						</View>
						<Text style={[styles.text, { marginLeft: 0, fontSize: 10, color: '#000' }]}>- Foco</Text>
					</View>
					<Text style={[styles.defaultText, { color: '#465568' }]}>
						Haz las cosas de a una por vez, el desarrollo personal se basa en pequeñas tareas rutinarias. Divide las grandes tareas en pequeñas
						acciones y pronto habrás avanzando sin darte cuenta.
					</Text>
				</View>
				<View style={{ marginLeft: 26 }}>
					<View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
						<View style={styles.circleNumber}>
							<Text style={[styles.text, { fontWeight: 'bold', fontSize: 10, color: '#000', margin: 0, marginLeft: 0 }]}>4</Text>
						</View>
						<Text style={[styles.text, { marginLeft: 0, fontSize: 10, color: '#000' }]}>- Practica, y vuelve a practicar</Text>
					</View>
					<Text style={[styles.defaultText, { color: '#465568' }]}>
						Dicen que la práctica hace al maestro. Mientras más practiques, más aprenderás. Es más, cuanto más te equivoques, más aprenderás.
					</Text>
				</View>
				<View style={{ marginLeft: 26 }}>
					<View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
						<View style={styles.circleNumber}>
							<Text style={[styles.text, { fontWeight: 'bold', fontSize: 10, color: '#000', margin: 0, marginLeft: 0 }]}>5</Text>
						</View>
						<Text style={[styles.text, { marginLeft: 0, fontSize: 10, color: '#000' }]}>- Sé perseverante</Text>
					</View>
					<Text style={[styles.defaultText, { color: '#465568' }]}>
						Aférrate a un plan, y no lo sueltes. Sigue adelante, si paras, no lograrás tus metas. De ti depende
					</Text>
				</View>
				<View style={{ marginLeft: 26 }}>
					<View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
						<View style={styles.circleNumber}>
							<Text style={[styles.text, { fontWeight: 'bold', fontSize: 10, color: '#000', margin: 0, marginLeft: 0 }]}>6</Text>
						</View>
						<Text style={[styles.text, { marginLeft: 0, fontSize: 10, color: '#000' }]}>- Equivócate y levántate</Text>
					</View>
					<Text style={[styles.defaultText, { color: '#465568' }]}>
						Todos cometemos errores, es parte del proceso de aprendizaje. No te detengas en lamentar los errores, pero sí aprende de ellos, obtén las
						lecciones aprendidas, procesa e incorpora esos aprendizajes a tu nueva rutina.
					</Text>
				</View>
				<View style={{ marginLeft: 26 }}>
					<View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
						<View style={styles.circleNumber}>
							<Text style={[styles.text, { fontWeight: 'bold', fontSize: 10, color: '#000', margin: 0, marginLeft: 0 }]}>7</Text>
						</View>
						<Text style={[styles.text, { marginLeft: 0, fontSize: 10, color: '#000' }]}>- Construye recuerdos de éxitos</Text>
					</View>
					<Text style={[styles.defaultText, { color: '#465568' }]}>
						Cuando sientas que no estás avanzando, cuando estés frustrado o presionado, recuerda qué te trajo hasta aquí, evoca los recuerdos de
						éxitos. Inunda tu mente con pensamientos y emociones positivas, tu confianza aumentará y continúa tu plan de acción.
					</Text>
				</View>
				<View style={{ marginLeft: 26 }}>
					<View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
						<View style={styles.circleNumber}>
							<Text style={[styles.text, { fontWeight: 'bold', fontSize: 10, color: '#000', margin: 0, marginLeft: 0 }]}>8</Text>
						</View>
						<Text style={[styles.text, { marginLeft: 0, fontSize: 10, color: '#000' }]}>- Solicita feedback</Text>
					</View>
					<Text style={[styles.defaultText, { color: '#465568' }]}>
						Escucha a los demás, a tus compañeros, jefes, colaboradores o personas de otras áreas, consúltales cómo lo estás haciendo, qué consideran
						que puedes mejorar. En base a su feedback, ajusta tu plan de acción.
					</Text>
				</View>
			</View>

			<View style={styles.footerPage}>
				<Text style={styles.pageNumber} render={({ pageNumber }) => `${pageNumber}`} fixed />

				<View style={styles.logoContainer}>
					<Image src='https://assets.mydna.company/mydnalogo.png' style={[styles.logo, { marginRight: 5 }]} />
					<Text style={[styles.defaultText, { color: '#465568', margin: 0, lineHeight: 0 }]}>powered by Witmegrow</Text>
				</View>
			</View>
		</Page>

		<Page style={styles.page}>
			<View style={[styles.roundedTextBox, { marginTop: 10 }]}>
				<Text style={styles.text}>¿Puedo confiar en mis resultados?</Text>
			</View>

			<View style={{ position: 'absolute', marginTop: 80 }}>
				<Text style={styles.defaultText}>
					Nuestra metodología ha sido probada en más de mil casos de estudio que permite contar con una herramienta de autoconocimiento verificada. Al
					mismo tiempo, cuenta con mecanismos dee validación que en caso de verificar una anomalía, propondrán de rehacer la autoevaluación.
				</Text>
				<Text style={styles.defaultText}>
					Creemos que más allá de los resultados que obtengas, todas las personas contamos con oportunidades para mejorar nuestras habilidades, con el
					fin dee lograr mayor armonía y bienestar en todos los ámbitos de relacionamiento con otros y con nosotros mismos. Te invitamos a utilizarlo
					como una herramienta de auto- conocimiento para continuar esforzándote en tu camino de desarrollo personal y profesional.
				</Text>
			</View>

			<View style={styles.footerPage}>
				<Text style={styles.pageNumber} render={({ pageNumber }) => `${pageNumber}`} fixed />

				<View style={styles.logoContainer}>
					<Image src='https://assets.mydna.company/mydnalogo.png' style={[styles.logo, { marginRight: 5 }]} />
					<Text style={[styles.defaultText, { color: '#465568', margin: 0, lineHeight: 0 }]}>powered by Witmegrow</Text>
				</View>
			</View>
		</Page>

		<Page style={[styles.page, { padding: 0 }]}>
			<Link src='https://mydnadigital.com/' style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
				<Image src='https://assets.mydna.company/pdf-assessment/page-solutions.jpg' cache style={{ height: '100%' }} />
			</Link>
		</Page>

		<Page style={[styles.page, { padding: 0 }]}>
			<Link src='mailto:contacto@mydnadigital.com' style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
				<View style={{ position: 'absolute', backgroundColor: '#000', width: '100%', height: '20px', top: 0, left: 50 }} />
				<Image src='https://assets.mydna.company/pdf-assessment/closing-page-without-social.jpg' cache style={{ height: '100%' }} />
			</Link>
		</Page>
	</Document>
)

Font.register({
	family: 'Euclid Circular B',
	fonts: [
		{
			src: EuclidRegular,
			fontWeight: 'normal',
		},
		{
			src: EuclidBold,
			fontWeight: 'bold',
		},
		{
			src: EuclidItalic,
			fontStyle: 'italic',
		},
	],
})

const styles = StyleSheet.create({
	page: {
		position: 'relative',
		backgroundColor: '#FFFFFF',
		width: '100%',
		padding: 10,
	},
	backgroundImage: {
		position: 'absolute',
		width: '100%',
		height: '100%',
	},
	roundedBox: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		width: '80%',
		backgroundColor: '#7c6cec',
		borderTopRightRadius: 20,
		padding: 20,
	},
	headerText: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: '#FFFFFF',
		fontSize: 12,
		marginBottom: 22,
		marginLeft: 10,
	},
	title: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'bold',
		color: '#FFFFFF',
		fontWeight: 900,
		fontSize: 42,
		marginBottom: 22,
		marginLeft: 10,
	},
	name: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: '#FFFFFF',
		fontSize: 18,
		marginBottom: 22,
		marginLeft: 10,
	},
	description: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: '#FFFFFF',
		fontSize: 10,
		marginBottom: 22,
		marginLeft: 10,
		lineHeight: 1.5,
	},
	defaultText: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: 'black',
		fontSize: 10,
		marginBottom: 14,
		marginHorizontal: 26,
		lineHeight: 1.5,
	},
	footer: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: '#FFFFFF',
		fontSize: 10,
		marginBottom: 22,
		marginLeft: 10,
	},

	//Tag for TitlePages
	roundedTextBox: {
		position: 'absolute',
		width: 'auto',
		// maxWidth: 350,
		left: 0,
		padding: 10,
		backgroundColor: '#7c6cec',
		borderTopRightRadius: 35,
		borderBottomRightRadius: 35,
		marginBottom: 20,
	},
	text: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'bold',
		color: '#FFFFFF',
		fontSize: 18,
		marginLeft: 10,
		marginRight: 10,
		fontWeight: 700,
	},

	detailContainer: {
		position: 'absolute',
		bottom: 350,
		left: 20,
		flexDirection: 'row',
		alignItems: 'center',
	},
	blueCircle: {
		width: 10,
		height: 10,
		borderRadius: 5,
		backgroundColor: '#00AEEF',
		marginRight: 5,
	},
	whiteRectangle: {
		width: 25,
		height: 5,
		backgroundColor: '#FFFFFF',
		borderRadius: 2.5,
		marginRight: 5,
	},
	greenCircle: {
		width: 10,
		height: 10,
		borderRadius: 5,
		backgroundColor: '#00C853',
		marginRight: 5,
	},

	//ContainerDimensions
	container: {
		marginLeft: 20,
		marginRight: 20,
		flexDirection: 'row',
		alignItems: 'center',
		backgroundColor: '#0078D4',
		padding: 10,
		borderRadius: 10,
	},
	iconContainer: {
		paddingLeft: 19,
		width: 20,
		height: 20,
		borderRadius: 20,
		backgroundColor: '#FFFFFF',
		justifyContent: 'center',
		alignItems: 'center',
		marginRight: 4,
	},
	textContainer: {
		display: 'flex',
	},
	defaultTextContainer: {
		fontFamily: 'Euclid Circular B',
		fontWeight: 'normal',
		color: 'black',
		fontSize: 10,
	},

	pill: {
		margin: 2,
		padding: 4,
		backgroundColor: '#008ACD',
		color: '#fff',
		borderRadius: 20,
		fontSize: 10,
		flexBasis: 'auto',
		width: 'auto',
	},

	progressBarContainer: {
		marginLeft: 20,
		marginRight: 20,
		width: '100%',
		backgroundColor: '#E0F3FC',
		borderRadius: 12,
		height: 12,
		overflow: 'hidden',
		marginBottom: 10,
	},
	progressBarFill: {
		backgroundColor: '#008ACD',
		height: '100%',
		borderRadius: 12,
	},

	containerSpecs: {
		display: 'flex',
		flexDirection: 'row',
		border: '1px solid #E0E0E0',
		borderRadius: 8,
		marginBottom: 10,
		overflow: 'hidden',
		width: '100%',
	},
	leftBox: {
		backgroundColor: '#008ACD',
		padding: 10,
		width: '30%',
		color: 'white',
	},
	rightBox: {
		padding: 10,
		width: '70%',
	},
	listText: {
		fontSize: 10,
		marginBottom: 3,
	},

	layoutContainer: {
		padding: 10,
		border: '1px solid #E0E0E0',
		borderRadius: 8,
		width: '100%',
	},
	layoutHeader: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		backgroundColor: '#008ACD',
		padding: 10,
		color: 'white',
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
	},
	layoutTitle: {
		fontSize: 14,
		fontWeight: 'bold',
	},
	layoutPercentage: {
		fontSize: 14,
		fontWeight: 'bold',
	},
	layoutContent: {
		padding: 10,
		borderBottom: 8,
	},
	layoutRow: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginBottom: 5,
	},
	layoutColumn: {
		width: '45%',
	},
	layoutSubtitle: {
		fontSize: 12,
		fontWeight: 'bold',
		marginBottom: 5,
	},
	layoutParagraph: {
		fontSize: 10,
		marginBottom: 5,
	},
	layoutBadge: {
		backgroundColor: '#E3F2FD',
		color: '#007BFF',
		fontSize: 10,
		padding: '2px 4px',
		borderRadius: 8,
		alignSelf: 'flex-start',
	},

	circleNumber: {
		width: 16,
		height: 16,
		borderRadius: 15,
		backgroundColor: '#f1f4f9',
		justifyContent: 'center',
		alignItems: 'center',
		marginRight: 10,
	},

	footerPage: {
		position: 'absolute',
		bottom: 10,
		left: 0,
		right: 0,
		height: 50,
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		paddingHorizontal: 30,
	},
	pageNumber: {
		fontSize: 10,
		color: '#000',
	},
	logoContainer: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	logo: {
		width: 60,
		height: 'auto',
	},

	containerOptions: {
		backgroundColor: '#f5f8fa',
		borderRadius: 10,
		padding: 10,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: 5,
		marginBottom: 20,
		marginLeft: 20,
		marginRight: 20,
	},
	option: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	circle: {
		width: 10,
		height: 10,
		borderRadius: 5,
		borderWidth: 1,
		borderColor: '#E69138',
		marginRight: 4,
	},
})

const PDFButton = ({ name, active, employeeId }) => {
	const employee = {
		employeeId: employeeId,
		name: name,
	}

	const mockCompetence = [
		{
			title: 'Organizacional',
			color: '#008acd',
			items: [
				{
					title: 'ORIENTACIÓN AL CLIENTE',
					text: 'La capacidad para encaminar todos los actos hacia la meta esperada, actuando con velocidad y sentido de urgencia ante decisiones importantes necesarias.',
				},
				{
					title: 'PENSAMIENTO ESTRATÉGICO',
					text: 'Es un proceso dinámico, flexible, que permite y hasta fuerza modificaciones en los planes, a fin de responder a las cambiantes circunstancias.',
				},
				{
					title: 'NEGOCIACIÓN EFECTIVA',
					text: 'Es un proceso en el que dos o más personas intercambian ideas con la intención de modificar sus relaciones y alcanzar un acuerdo tendiente a satisfacer necesidades mutuas.',
				},
				{
					title: 'CREATIVIDAD E INNOVACIÓN',
					text: 'La creatividad como habilidad para imaginar y conceptualizar ideas nuevas y originales, y la innovación como habilidad para que esas ideas se incorporen en nuestra vida, con el fin de hacerla más sencilla.',
				},
				{
					title: 'GESTIÓN EFECTIVA DEL TIEMPO',
					text: 'Habilidad para equilibrar las tareas diarias, fijando prioridades, con el fin de lograr una mayor productividad y eficiencia.',
				},
			],
		},

		{
			title: 'Social',
			color: '#6c4fdb',
			items: [
				{
					title: 'INCLUSIÓN Y DIVERSIDAD',
					text: 'La diversidad como el conjunto de características que nos hacen diferentes a los demás y la inclusión como la mezcla que hace que esas diferencias funcionen juntas.',
				},
				{
					title: 'COMUNICACIÓN EFECTIVA',
					text: 'Es la capacidad de escuchar, comprender e interpretar de manera correcta la información de otro y a la vez de transmitir de manera adecuada, asegurándose de que el mensaje sea recibido.',
				},
				{
					title: 'RELACIONES INTERPERSONALES',
					text: 'Las relaciones implican gestionar emociones positivas y negativas, propias y de otros, con el fin de enfrentarse a sucesos desagradables y también a sucesos emocionantes.',
				},
				{
					title: 'TRABAJO EN EQUIPO',
					text: 'Capacidad de lograr objetivos compartidos por todos los integrantes de manera consciente, mancomunada, coordinada y colaborativa.',
				},
				{
					title: 'ORIENTACIÓN A RESULTADOS',
					text: 'La capacidad para encaminar todos los actos hacia la meta esperada, actuando con velocidad y sentido de urgencia ante decisiones importantes necesarias.',
				},
			],
		},

		{
			title: 'Líder',
			color: '#00a28b',
			items: [
				{
					title: 'VISIÓN INSPIRADORA',
					text: 'Actitud de curiosidad y apertura, con el fin de lograr un aprendizaje de cada situación a lo largo de la vida.',
				},
				{
					title: 'TOMA DE DECISIONES',
					text: 'Vivir significa elegir; no tomar decisiones implica inmovilidad y bloqueo. Muchas veces funciona la intuición: tomar decisiones con el corazón y utilizar la mente para que funcionen.',
				},
				{
					title: 'GESTIÓN DEL CAMBIO',
					text: 'La gestión del cambio busca facilitar y conseguir la implementación exitosa de los procesos de transformación, lo que implica trabajar con y para las personas en la aceptación y asimilación de los cambios y en la reducción de la resistencia a los mismos.',
				},
				{
					title: 'LÍDER COACH',
					text: 'Busca mostrar nuevas posibilidades a sus equipos, ayudándolos a tomar decisiones que antes no eran obvias para ellos.',
				},
			],
		},

		{
			title: 'Persona',
			color: '#d87706',
			items: [
				{
					title: 'RESILIENCIA',
					text: 'Las personas que lo son no creen que exista una vida dura, sino momentos difíciles.',
				},
				{
					title: 'FLEXIBILIDAD',
					text: 'Habilidad de reconocer un entorno en el cual lo único constante es el cambio y a su vez, tener la plasticidad para adaptar las conductas, decisiones, estrategias, y relaciones a dicho entorno y sus necesidades.',
				},
				{
					title: 'APRENDIZAJE CONTINUO',
					text: 'Se refiere a la actitud de curiosidad y apertura para el aprendizaje a lo largo de la vida.',
				},
				{
					title: 'EMPATÍA',
					text: 'Es el arte consciente de crear puentes de vulnerabilidad y compasión `con` y `para` el otro.',
				},
				{
					title: 'BALANCE DE VIDA PERSONAL-LABORAL',
					text: 'Armonía entre el desarrollo profesional y las metas personales, con el fin de que el ser humano se siente protagonista de su destino y bienestar integral.',
				},
				{
					title: 'AUTOCONOCIMIENTO',
					text: 'Capacidad para percibirse a uno mismo y al entorno de una manera consciente.',
				},
			],
		},
	]

	const [loading, setLoading] = useState(false)

	const [keywords, setKeywords] = useState(null)
	const [allScores, setAllScores] = useState(null)
	const [dimensions, setDimensions] = useState(null)
	const [strengthWeakness, setStrengthWeakness] = useState(null)

	const loadData = useCallback(async () => {
		try {
			const [getKeywords, getDimensions, getStrengthWeakness, getAllScore] = await Promise.all([
				Assessment.getKeywords(employeeId),
				Assessment.getDimensions(employeeId),
				Assessment.getStrengthWeakness(employeeId),
				Assessment.getStrengthWeaknessAllScore(employeeId),
			])
			setAllScores(getAllScore)
			setKeywords(getKeywords)
			setDimensions(getDimensions)
			setStrengthWeakness(getStrengthWeakness)
		} catch {
			console.error('Erro ao carregar os dados')
		} finally {
		}
	}, [employeeId])

	const mergeScores = (mockCompetence, allScores) => {
		if (!allScores || !allScores.strengths || !allScores.weaknesses) {
			return mockCompetence
		}

		const combinedScores = [...allScores.strengths, ...allScores.weaknesses]

		const updatedCompetence = mockCompetence.map(category => {
			const updatedItems = category.items.map(item => {
				const matchedScore = combinedScores.find(
					score =>
						score.description.toLowerCase().includes(item.title.toLowerCase()) || item.title.toLowerCase().includes(score.description.toLowerCase())
				)

				return {
					...item,
					score: matchedScore ? matchedScore.score * 5 : null,
				}
			})

			return {
				...category,
				items: updatedItems,
			}
		})

		return updatedCompetence
	}

	const handleOpenPDF = async () => {
		if (!active || loading) return
		setLoading(true)
		await loadData()

		if (!keywords || !dimensions || !strengthWeakness || !allScores) {
			console.error('Erro on loading data')
			setLoading(false)
			return
		}

		const updatedMockCompetence = mergeScores(mockCompetence, allScores)

		const doc = (
			<MyPDFDocument
				data={employee}
				keywords={keywords}
				dimensions={dimensions}
				strengthWeakness={strengthWeakness}
				mockCompetence={updatedMockCompetence}
			/>
		)

		const asPdf = pdf([])
		asPdf.updateContainer(doc)

		const blob = await asPdf.toBlob()
		const url = URL.createObjectURL(blob)
		window.open(url, '_blank')
		setLoading(false)
	}

	const hasLoaded = useRef(false)

	useEffect(() => {
		if (active && !hasLoaded.current) {
			loadData()
			hasLoaded.current = true
		}
	}, [active, loadData])

	return (
		<button
			onClick={handleOpenPDF}
			className={`tw-rounded-full tw-p-1 tw-w-[42px] tw-h-[42px] tw-bg-white ${
				active !== true
					? 'tw-text-gray-300 border-gray'
					: loading
					? 'tw-text-purple-500 border-primary'
					: 'tw-text-purple-500 hover:tw-bg-purple-500 border-primary hover:tw-text-white'
			} tw-flex tw-items-center tw-justify-center border`}
			disabled={active !== true || loading}
		>
			{loading ? <Spinner animation='border' variant='primary' /> : <HiArrowDownTray size={22} />}
		</button>
	)
}
export default PDFButton
